.ItemBreakdown,
.PassiveBreakdown {
  left: -6em;
  right: -6em;
  z-index: 110;
  position: absolute;
}
.ItemBreakdown .Contents,
.PassiveBreakdown .Contents {
  width: 16em;
  margin: auto;
  font-size: 1.25rem;
  position: relative;
  border-style: solid;
  border-width: 0.3em;
  border-radius: 0.25em;
  border-color: #111111;
  background-color: #e7e7e7;
  color: #111111;
  font-family: var(--base-font);
  overflow: hidden;
  pointer-events: none;
}
.ItemBreakdown .Contents[isSmall],
.PassiveBreakdown .Contents[isSmall] {
  width: 13em;
}
.ItemBreakdown .Contents .Icon,
.PassiveBreakdown .Contents .Icon {
  top: 0.4em;
  right: 0.4em;
  width: 3em;
  height: 3em;
  position: absolute;
  opacity: 0.3;
  mix-blend-mode: multiply;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.ItemBreakdown .Contents .Summary,
.PassiveBreakdown .Contents .Summary {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.809em;
  padding-right: 0.809em;
}
.ItemBreakdown .Contents .Summary .Title,
.PassiveBreakdown .Contents .Summary .Title {
  font-size: 1.4em;
  line-height: 1em;
  font-weight: bold;
  text-decoration: underline;
  font-family: var(--header-font);
  margin-bottom: 0.2em;
}
.ItemBreakdown .Contents .KeywordDefinition,
.PassiveBreakdown .Contents .KeywordDefinition {
  opacity: 0.5;
  mix-blend-mode: multiply;
  font-style: italic;
  padding-left: 0.809em;
  padding-right: 0.809em;
  padding-bottom: 0.5em;
  display: none;
}
.ItemBreakdown .Contents .KeywordDefinition[hasKeyword],
.PassiveBreakdown .Contents .KeywordDefinition[hasKeyword] {
  display: block;
}
.ItemBreakdown .Contents .KeywordDefinition .Text,
.PassiveBreakdown .Contents .KeywordDefinition .Text {
  font-size: 0.75em;
}
.ItemBreakdown .Contents .PowerCalculation,
.PassiveBreakdown .Contents .PowerCalculation {
  padding-left: 4em;
  display: none;
}
.ItemBreakdown .Contents .PowerCalculation[isRendered],
.PassiveBreakdown .Contents .PowerCalculation[isRendered] {
  display: block;
}
.ItemBreakdown .Contents .Flavor,
.PassiveBreakdown .Contents .Flavor {
  opacity: 0.5;
  mix-blend-mode: multiply;
  font-style: italic;
  padding-left: 0.809em;
  padding-right: 0.809em;
  padding-bottom: 0.5em;
  display: none;
}
.ItemBreakdown .Contents .Flavor[isRendered],
.PassiveBreakdown .Contents .Flavor[isRendered] {
  display: block;
}
.ItemBreakdown .Contents .Flavor .Text,
.PassiveBreakdown .Contents .Flavor .Text {
  font-size: 0.5em;
}
.ItemBreakdown .Contents .Elements,
.PassiveBreakdown .Contents .Elements {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.809em;
  padding-right: 0.809em;
  display: none;
}
.ItemBreakdown .Contents .Elements[isRendered],
.PassiveBreakdown .Contents .Elements[isRendered] {
  display: block;
}
.ItemBreakdown .Contents .Elements[element=fire],
.PassiveBreakdown .Contents .Elements[element=fire] {
  background: linear-gradient(180deg, #e7e7e7 0%, #d54b33 100%);
}
.ItemBreakdown .Contents .Elements[element=earth],
.PassiveBreakdown .Contents .Elements[element=earth] {
  background: linear-gradient(180deg, #e7e7e7 0%, #62C370 100%);
}
.ItemBreakdown .Contents .Elements[element=water],
.PassiveBreakdown .Contents .Elements[element=water] {
  background: linear-gradient(180deg, #e7e7e7 0%, #639bff 100%);
}
.ItemBreakdown .Contents .Elements .Effectiveness,
.PassiveBreakdown .Contents .Elements .Effectiveness,
.ItemBreakdown .Contents .Elements .Ineffectiveness,
.PassiveBreakdown .Contents .Elements .Ineffectiveness {
  font-size: 0.75em;
}
.Keyword {
  font-weight: bold;
  position: relative;
}
.Keyword[link]::after {
  content: "";
  width: 95%;
  height: 1px;
  left: 0em;
  right: 0em;
  bottom: 0em;
  margin: auto;
  position: absolute;
  border-bottom-width: 0.15em;
  border-bottom-style: dotted;
  border-bottom-color: #111111;
}
.Keyword.fire,
.Keyword[element=fire],
.Keyword[element=sword],
.Keyword[element=swords] {
  color: #732e22;
}
.Keyword.fire[link]::after,
.Keyword[element=fire][link]::after,
.Keyword[element=sword][link]::after,
.Keyword[element=swords][link]::after {
  border-bottom-color: #732e22;
}
.Keyword.earth,
.Keyword[element=earth],
.Keyword[element=axe],
.Keyword[element=axes] {
  color: #3a6a41;
}
.Keyword.earth[link]::after,
.Keyword[element=earth][link]::after,
.Keyword[element=axe][link]::after,
.Keyword[element=axes][link]::after {
  border-bottom-color: #3a6a41;
}
.Keyword.water,
.Keyword[element=water],
.Keyword[element=bow],
.Keyword[element=bows],
.Keyword[element=spear],
.Keyword[element=spears] {
  color: #3a5688;
}
.Keyword.water[link]::after,
.Keyword[element=water][link]::after,
.Keyword[element=bow][link]::after,
.Keyword[element=bows][link]::after,
.Keyword[element=spear][link]::after,
.Keyword[element=spears][link]::after {
  border-bottom-color: #3a5688;
}
.Highlighted {
  color: #111111;
  padding: 0.05em 0.3em;
  display: inline-block;
}
.Highlighted[element=fire] {
  background-color: #d54b33;
}
.Highlighted[element=earth] {
  background-color: #62C370;
}
.Highlighted[element=water] {
  background-color: #639bff;
}
